import { render, staticRenderFns } from "./Code.vue?vue&type=template&id=7fca93a0&scoped=true&"
import script from "./Code.vue?vue&type=script&lang=js&"
export * from "./Code.vue?vue&type=script&lang=js&"
import style0 from "./Code.vue?vue&type=style&index=0&id=7fca93a0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fca93a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fca93a0')) {
      api.createRecord('7fca93a0', component.options)
    } else {
      api.reload('7fca93a0', component.options)
    }
    module.hot.accept("./Code.vue?vue&type=template&id=7fca93a0&scoped=true&", function () {
      api.rerender('7fca93a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popup/Code.vue"
export default component.exports